export const constants = [{
    btnText1: 'MAIS CONTROLE',
    btnText2: 'PRÉ-PAGO',
    title1: 'Escolha o valor na primeira recarga e as próximas são automáticas sempre que seu saldo estiver acabando.',
    title2: 'Recarga mínima para pagar pedágios e estacionamentos: R$ 50,00',
    textTitleTable: 'Tempo de isenção',
    textTitleTable2: '... mensalidades grátis',
    table: [
        {
            campo: 'Taxa de adesão grátis',
            campo2: 'Check'
        },
        {
            campo: 'Entrega da tag grátis',
            campo2: 'Check'
        },
        {
            campo: 'Sem fidelidade',
            campo2: 'Check'
        },
        {
            campo: 'Mensalidade após ... meses',
            campo2: 'Check'
        },
        {
            campo: 'Mensalidade após ... meses ',
            classCampo2: '',
            campo2: 'R$ 18,90'
        }
    ],
    btnText: 'Quero Pré-Pago',
},
{
    btnText1: 'MAIS PRATICIDADE',
    btnText2: 'PÓS-PAGO',
    // title1: 'Escolha o valor na primeira recarga e as próximas são automáticas sempre que seu saldo estiver acabando.',
    // title2: 'Recarga mínima para pagar pedágios e estacionamentos: R$ 50,00',
    textTitleTable: 'Tempo de isenção',
    textTitleTable2: '... mensalidades grátis',
    table: [
        {
            campo: 'Taxa de adesão grátis',
            campo2: 'Check'
        },
        {
            campo: 'Entrega da tag grátis',
            campo2: 'Check'
        },
        {
            campo: 'Sem fidelidade',
            campo2: 'Check'
        },
        {
            campo: 'Mensalidade após ... meses',
            campo2: 'Check'
        },
        {
            campo: 'Mensalidade após ... meses ',
            classCampo2: '',
            campo2: 'R$ 20,90'
        }
    ],
    btnText: 'Quero Pós-Pago',
}]
